<template>
  <a-select
    allowClear
    :mode="mode"
    show-search
    :maxTagCount="4"
    style="width: 100%"
    :placeholder="_selfPlaceholder"
    :disabled="_selfDisabled"
    :default-active-first-option="false"
    v-model="selectedValue"
    :filter-option="filterOption"
    :not-found-content="loading ? undefined : null"
    @focus="getList"
    @change="onChange"
  >
    <a-spin v-if="loading" slot="notFoundContent" size="small" />
    <a-select-option v-for="(item, index) in option" :value="String(item[valueName])" :key="index">
      {{ item[labelName] }}
    </a-select-option>
  </a-select>
</template>

<script>
import http from '@/service/axios'
import api from '@/service/api'
// 通过接口调用获取list
export default {
  props: {
    placeholder: {},
    disabled: {},
    code: {},
    name: {},
    mode: {
      type: String,
      default: '',
    },
    api: {
      type: String,
    },
    params: {
      type: Object,
      default: () => {
        return {}
      },
    },
    init: {
      //是否在mounted调用getList
      type: Boolean,
      default: false,
    },
    selectOne: {
      //列表页只有一个选项是否默认选中
      type: Boolean,
      default: true,
    },
    valueName: {
      type: String,
      default: 'code',
    },
    labelName: {
      type: String,
      default: 'name',
    },
  },
  data() {
    return {
      selectedValue: undefined,
      option: [],
      loading: false,
    }
  },
  mounted() {
    if (this.init) {
      this.getList()
    }
  },
  computed: {
    _selfPlaceholder() {
      return this.placeholder
    },
    _selfDisabled() {
      return this.disabled || false
    },
  },
  watch: {
    code() {
      if (this.option.length > 0) {
        this.setDefault()
      } else if (!this.name) {
        this.getList()
      }
    },
    name: {
      handler(val) {
        if (val) {
          this.selectedValue = val
        }
      },
      immediate: true,
    },
  },
  methods: {
    async getList() {
      if (this.option.length > 0) return
      this.loading = true
      let res = await http({
        url: api[this.api],
        data: {
          ...this.params,
        },
      })
      this.loading = false
      let list = res.result.list || res.result || []
      if (list.length === 0) {
        this.$message.warning(this.$t('数据为空'))
      }
      this.option = list
      this.setDefault()
    },
    setDefault() {
      if (this.name) return
      this.selectedValue = undefined
      if (this.code != undefined) {
        this.onChange(this.code)
      } else if (this.option.length === 1 && this.selectOne) {
        this.onChange(this.option[0][this.valueName])
      }
    },
    onChange(value) {
      // console.log('value: ', value)
      if (value !== undefined) {
        value = String(value)
      }
      this.selectedValue = value
      this.$emit('update:code', value)
      let item = this.option.find((elem) => String(elem[this.valueName]) === value) || {}
      this.$emit('update:name', item[this.labelName])
      this.$emit('change', item)
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      )
    },
  },
}
</script>
